export default "/e891d4a0bdc60f2a6a9b4e97d7422547d2a79dc5/aadf7e204ac3ecb8628e2b693a3c4a40.svg";